import React, { useState, useEffect } from "react";
import numeral from "numeral";
import ScheduledDebitCredit from "../subcompo/ScheduledDebitCredit";
import StatusAndComments from "../subcompo/underwriting-page/StatusAndComments";
// style constants
const headerStyle = {
  backgroundColor: "#2f75b5",
  color: "#FFF",
  fontWeight: "bold",
  fontFamily: "MontserratSemiBold",
  borderLeft: "1px solid white",
  borderRight: "1px solid white",
  borderTop: "none",
  fontSize: "1.1rem",
  borderRadius: "13px",
  boxShadow: "none",
  padding: "16px 0px 16px 0px",
  textShadow: "0px 0px",
  width: "210px !important",
};
const cellStyle = {
  borderLeft: "1px solid white",
  borderRight: "1px solid white",
  borderTop: "1px solid white",
  borderBottom: "1px solid white",
  borderRadius: "5px",
  boxShadow: "none",
  fontSize: "1.5rem",
  textShadow: "0px 0px",
  padding: "16px 0px 16px 0px",
};
const AddCarrier = ({
  columns,
  updateColumns,
  payrollData,
  formatPayroll,
  stateCarrierData,
  setStateCarrierData,
  updatePopUpData,
  allCarriersData,
}) => {
  //states
  const [carrierData, setCarrierData] = useState([]);
  const [premiumData, setPremiumData] = useState({});
  const [statusData, setStatusData] = useState({});
  const [commentData, setCommentData] = useState({});
  const [stateTypeData, setStateTypeData] = useState({});
  const [buttonCounter, setButtonCounter] = useState(0);
  const [totalPremium, setTotalPremium] = useState({});
  const [addData, setAddData] = useState({ status: "", data: {}, index: 0 });
  const [carrierStatusAndComments, setCarrierStatusAndComments] = useState({});
  const [currentCarriersData, setCurrentCarriersData] = useState([]);

  const modifiedCarrierData = allCarriersData.map((carrier) =>
    carrier.replace(/\s/g, "")
  );

  let completeCarriers = [...allCarriersData, ...modifiedCarrierData];
  const uniqueCarriers = [...new Set(completeCarriers)];

  // constants
  const render = (rowData) => {
    return (
      <div className="d-flex">
        <div className="d-flex w-100 flex-column">
          {rowData.name !== "TOTAL" ? (
            <>
              <span
                className="small-text-quote-table dark-blue"
                style={{
                  marginBottom: "10px",
                }}
              >
                <select
                  className="uw-options"
                  style={{
                    textAlign: "center",
                  }}
                  onChange={(e) => {
                    handleUWChange(e, rowData.name, buttonCounter, "stateType");
                    stateCarrierData[
                      Object.keys(stateCarrierData)[columns.length - 1]
                    ][rowData.name.toLowerCase()].stateType = e.target.value;
                    setStateCarrierData(stateCarrierData);
                  }}
                  value={
                    stateCarrierData[
                      Object.keys(stateCarrierData)[columns.length - 1]
                    ]
                      ? stateCarrierData[
                          Object.keys(stateCarrierData)[columns.length - 1]
                        ][rowData.name.toLowerCase()].stateType
                      : ""
                  }
                >
                  <option value="Select">Select</option>
                  <option value="MASTER">MASTER</option>
                  <option value="MCP">MCP</option>
                  <option value="MONO">MONO</option>
                </select>
              </span>
              <span
                className={
                  "small-text-quote-table " +
                  (rowData.type?.toUpperCase() === "MONO"
                    ? "red-text"
                    : "green-text")
                }
                style={{
                  marginBottom: "10px",
                }}
              >
                <input
                  type="number"
                  name="premiumInput"
                  placeholder="Enter Premium"
                  id="premiumInput"
                  min={0}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault();
                    }
                  }}
                  onBlur={(e) => {
                    handleUWChange(
                      e,
                      rowData.name,
                      buttonCounter,
                      "premium",
                      columns.length
                    );
                  }}
                  style={{
                    width: "9em",
                    height: "1.7em",
                    fontSize: "16px",
                    fontFamily: "'MontserratRegular'",
                  }}
                />
              </span>
            </>
          ) : (
            <span
              className={
                "small-text-quote-table " +
                (rowData.type?.toUpperCase() === "MONO"
                  ? "red-text"
                  : "green-text")
              }
              style={{
                marginBottom: "10px",
              }}
            >
              {numeral(totalPremium[columns.length]).format("$0,0")}
            </span>
          )}
          <span
            className="small-text-quote-table blue-text"
            style={
              rowData.name === "TOTAL"
                ? {
                    marginBottom: "10px",
                  }
                : {
                    marginBottom: "10px",
                  }
            }
          >
            {formatPayroll(payrollData[rowData?.name])}
          </span>
          {rowData.name !== "TOTAL" && (
            <div
              style={{
                position: "relative",
                top: "10px",
              }}
            >
              <span
                className="small-text-quote-table"
                style={{ marginBottom: "10px" }}
              >
                <ScheduledDebitCredit />
              </span>
              <span
                style={{
                  width: "125%",
                  marginBottom: "10px",
                }}
              >
                <select
                  className="uw-options"
                  style={{
                    textAlign: "center",
                  }}
                  onChange={(e) => {
                    handleUWChange(e, rowData.name, buttonCounter, "status");
                    stateCarrierData[
                      Object.keys(stateCarrierData)[columns.length - 1]
                    ][rowData.name.toLowerCase()].status = e.target.value;
                    setStateCarrierData(stateCarrierData);
                  }}
                  value={
                    stateCarrierData[
                      Object.keys(stateCarrierData)[columns.length - 1]
                    ]
                      ? stateCarrierData[
                          Object.keys(stateCarrierData)[columns.length - 1]
                        ][rowData.name.toLowerCase()].status
                      : ""
                  }
                >
                  <option value="select">Select</option>
                  <option value="bound">Bound</option>
                  <option value="quoted">Quoted</option>
                  <option value="closed">Closed</option>
                  <option value="declined">Declined</option>
                  <option value="uw_questions">UW Questions</option>
                  <option value="submitted">Submitted</option>
                </select>
              </span>
              <span
                style={{
                  marginBottom: "10px",
                }}
              >
                <textarea
                  style={{
                    marginBottom: "10px",
                  }}
                  className="uw-comment"
                  onChange={(e) => {
                    handleUWChange(e, rowData.name, buttonCounter, "comment");
                    stateCarrierData[
                      Object.keys(stateCarrierData)[columns.length - 1]
                    ][rowData.name.toLowerCase()].comment = e.target.value;
                    setStateCarrierData(stateCarrierData);
                  }}
                  value={
                    stateCarrierData[
                      Object.keys(stateCarrierData)[columns.length - 1]
                    ]
                      ? stateCarrierData[
                          Object.keys(stateCarrierData)[columns.length - 1]
                        ][rowData.name.toLowerCase()].comments
                      : ""
                  }
                />
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };
  const new_column_data = (carrierName, id) => ({
    title: (
      <div className="d-flex justify-content-center">
        <span>
          <i
            onClick={() => handleEditCarrierClick(id, carrierName)}
            className="bi bi-pen"
          />
        </span>
        <span className="w-75">{carrierName}</span>
        <input
          name="radio-input-uw-table"
          type="radio"
          value={carrierName}
          onClick={(e) => {
            let val = e.target.value;
            updatePopUpData({
              show: true,
              title: "",
              children: (
                <StatusAndComments
                  updateCarrierStatusAndComments={setCarrierStatusAndComments}
                  carrierStatusAndComments={carrierStatusAndComments}
                  carrier={val}
                />
              ),
              acceptBtn: "Update",
              rejectBtn: "Cancel",
              acceptBtnCallback: () => {
                for (let state in stateCarrierData[
                  "custom_carrier_" + carrierName
                ]) {
                  if (state !== "index") {
                    if (carrierStatusAndComments?.[carrierName]?.["status"])
                      stateCarrierData["custom_carrier_" + carrierName][
                        state
                      ].status =
                        carrierStatusAndComments[carrierName]["status"];
                    if (carrierStatusAndComments?.[carrierName]?.["comments"])
                      stateCarrierData["custom_carrier_" + carrierName][
                        state
                      ].comments =
                        carrierStatusAndComments[carrierName]["comments"];
                  }
                }
                setStateCarrierData(stateCarrierData);
                setCarrierStatusAndComments({});
              },
              rejectBtnCallback: () => {
                setCarrierStatusAndComments({});
              },
            });
          }}
        />
      </div>
    ),
    field: carrierName,
    width: "140%",
    align: "center",
    headerStyle,
    cellStyle,
    render,
    id,
  });
  const stateList =
    stateCarrierData &&
    Object.keys(stateCarrierData).length > 0 &&
    stateCarrierData[Object.keys(stateCarrierData)[0]]
      ? Object.keys(stateCarrierData[Object.keys(stateCarrierData)[0]])
      : [];

  // useEffects
  // set StateCarrierData on unblur from comments/premium/status
  useEffect(() => {
    if (
      !premiumData.state &&
      !statusData.state &&
      !commentData.state &&
      !stateTypeData.state
    )
      return;
    const index = {
      premium: premiumData.buttonCounter,
      status: statusData.buttonCounter,
      comment: commentData.buttonCounter,
      stateType: stateTypeData.buttonCounter,
    };
    const updateCustomCarrierData = (data, state, value) => {
      if (state !== undefined) {
        data[state] = {
          ...data[state],
          ...value,
          debit_credit: { isChecked: false, value: "" },
          isChecked: false,
        };
      }
    };

    let customCarrierData =
      stateCarrierData && carrierData[index.premium] !== undefined
        ? stateCarrierData[`custom_carrier_${carrierData[index.premium]}`] || {}
        : {};
    updateCustomCarrierData(customCarrierData, premiumData.state, {
      premium: `$${Number(premiumData.data).toLocaleString("en")}`,
    });
    index.premium !== undefined &&
      (stateCarrierData[`custom_carrier_${carrierData[index.premium]}`] =
        customCarrierData);
    totalPremium[premiumData.length] = 0;
    for (let i in stateCarrierData[
      `custom_carrier_${carrierData[index.premium]}`
    ]) {
      totalPremium[premiumData.length] += numeral(
        stateCarrierData[`custom_carrier_${carrierData[index.premium]}`]?.[i]
          ?.premium
      ).value();
    }

    setTotalPremium(totalPremium);
    customCarrierData = stateCarrierData
      ? stateCarrierData[`custom_carrier_${carrierData[index.status]}`] || {}
      : {};
    updateCustomCarrierData(customCarrierData, statusData.state, {
      status: statusData.data,
    });
    index.status !== undefined &&
      (stateCarrierData[`custom_carrier_${carrierData[index.status]}`] =
        customCarrierData);

    customCarrierData = stateCarrierData
      ? stateCarrierData[`custom_carrier_${carrierData[index.comment]}`] || {}
      : {};
    updateCustomCarrierData(customCarrierData, commentData.state, {
      comments: commentData.data,
    });
    index.comment !== undefined &&
      (stateCarrierData[`custom_carrier_${carrierData[index.comment]}`] =
        customCarrierData);

    customCarrierData = stateCarrierData
      ? stateCarrierData[`custom_carrier_${carrierData[index.stateType]}`] || {}
      : {};
    updateCustomCarrierData(customCarrierData, stateTypeData.state, {
      stateType: stateTypeData.data,
    });
    index.stateType !== undefined &&
      (stateCarrierData[`custom_carrier_${carrierData[index.stateType]}`] =
        customCarrierData);

    setStateCarrierData(stateCarrierData);
    return () => {
      setPremiumData([]);
      setStatusData([]);
      setCommentData([]);
      setStateTypeData([]);
    };
  }, [premiumData, statusData, commentData, stateTypeData]);

  // update column and stateCarrierData when adding new carrier or editing existing carrier
  useEffect(() => {
    if (columns.length > 1) {
      const columnsCopy = columns.map((c, i) => {
        if (c.id == addData.id) {
          return addData.data;
        } else return c;
      });
      if (addData.status == "edit" && addData.data.field.length)
        Object.keys(stateCarrierData).map((s, i) => {
          if (stateCarrierData[s].index == addData.id) {
            stateCarrierData[`custom_carrier_${addData.data.field}`] =
              stateCarrierData[s];
            delete stateCarrierData[s];
            delete stateCarrierData["custom_carrier_undefined"];
            setStateCarrierData(stateCarrierData);
          }
        });
      updateColumns(columnsCopy);
    }
  }, [addData]);

  useEffect(() => {
    const updatedColumns = columns.map((c) => {
      if (c.field?.startsWith("custom_carrier_")) {
        return { ...c, render };
      }
      return c;
    });
    updateColumns(updatedColumns);
  }, [totalPremium]);

  const checkduplicatecarrier = (customcarrier, carrier) => {
    let currentCarriersDatafilter = currentCarriersData.filter(
      (item) => item !== carrier
    );
    if (
      customcarrier.includes("zurich") &&
      (uniqueCarriers.includes("zurich") ||
        currentCarriersData.includes("zurich"))
    ) {
      return true;
    }
    let duplicateCarrier =
      uniqueCarriers.includes(customcarrier) ||
      currentCarriersDatafilter.includes(customcarrier);

    if (!duplicateCarrier) {
      currentCarriersData.push(
        ...currentCarriersData,
        customcarrier?.toLowerCase()
      );
    }
    return duplicateCarrier;
  };
  // functions
  // add new column with input field as header and empty fields for premiums, status, comments
  const handleAddCarrierClick = () => {
    const id = Date.now();
    setButtonCounter(buttonCounter + 1);
    const new_column = {
      title: (
        <input
          type="text"
          autoFocus
          name="carrierText"
          id="carrierText"
          placeholder="Carrier Name"
          style={{ width: "8.5em", height: "1.7em" }}
          onBlur={(e) => {
            if (e.target.value.length > 0) {
              let carrierCheck = checkduplicatecarrier(
                e.target.value?.trim()?.toLowerCase()
              );
              const newAgentCarrier = e.target.value.trim();
              if (carrierCheck) {
                updatePopUpData({
                  show: true,
                  title: "Carrier already exists",
                  disableNoButton: true,
                  acceptBtn: "OK",
                  acceptBtnCallback: () => {},
                });
                e.target.value = "";
              } else {
                setCarrierData([...carrierData, e.target.value]);
                if (
                  Object.keys(stateCarrierData).includes(`custom_carrier_${id}`)
                ) {
                  stateCarrierData[`custom_carrier_${newAgentCarrier}`] =
                    stateCarrierData[`custom_carrier_${id}`];
                  delete stateCarrierData[[`custom_carrier_${id}`]];
                } else {
                  stateCarrierData[`custom_carrier_${newAgentCarrier}`] = {
                    index: id,
                  };
                  for (let state of stateList) {
                    stateCarrierData[`custom_carrier_${newAgentCarrier}`][
                      state.toLowerCase()
                    ] = {
                      debit_credit: { isChecked: false, value: "" },
                      isChecked: false,
                      stateType: "",
                    };
                  }
                }
                const new_column = new_column_data(newAgentCarrier, id);
                setAddData({
                  status: true,
                  data: new_column,
                  id: id,
                });
              }
            } else {
              stateCarrierData[`custom_carrier_${id}`] = { index: id };
              for (let state of stateList) {
                stateCarrierData[`custom_carrier_${id}`][state.toLowerCase()] =
                  {
                    debit_credit: { isChecked: false, value: "" },
                    isChecked: false,
                    stateType: "",
                  };
              }
            }
            delete stateCarrierData["custom_carrier_undefined"];
            setStateCarrierData(stateCarrierData);
          }}
        />
      ),
      field: "",
      width: "140%",
      align: "center",
      headerStyle,
      cellStyle,
      render,
      id,
    };
    updateColumns([...columns, new_column]);
  };

  // when clicked on edit button, column header turned into text input to update carrier name
  const handleEditCarrierClick = (id, carrier) => {
    const new_column = {
      title: (
        <input
          type="text"
          autoFocus
          name="carrierText"
          id="carrierText"
          placeholder="Carrier Name"
          style={{ width: "8.5em", height: "1.7em" }}
          onBlur={(e) => {
            if (e.target.value.length > 0) {
              let carrierCheck = checkduplicatecarrier(
                e.target.value?.trim()?.toLowerCase(),
                carrier
              );
              const newAgentCarrier = e.target.value.trim();
              if (carrierCheck) {
                updatePopUpData({
                  show: true,
                  title: "Carrier already exists",
                  disableNoButton: true,
                  acceptBtn: "OK",
                  acceptBtnCallback: () => {},
                });
                e.target.value = "";
              } else {
                setCarrierData([...carrierData, e.target.value]);
                const new_column = new_column_data(newAgentCarrier, id);
                setAddData({
                  status: "edit",
                  data: new_column,
                  id: id,
                });
              }
            }
          }}
        />
      ),
      field: "",
      width: "140%",
      align: "center",
      headerStyle,
      cellStyle,
      render,
      id,
    };
    setAddData({ status: "edit", id, data: new_column });
  };

  // when unblurred, used to update premium, comments, status
  const handleUWChange = (e, state, buttonCounter, type, length) => {
    type == "premium" &&
      setPremiumData({
        data: e.target.value,
        state: state.toLowerCase(),
        buttonCounter,
        length,
      });
    type == "status" &&
      setStatusData({
        data: e.target.value,
        state: state.toLowerCase(),
        buttonCounter,
      });
    type == "comment" &&
      setCommentData({
        data: e.target.value,
        state: state.toLowerCase(),
        buttonCounter,
      });
    type == "stateType" &&
      setStateTypeData({
        data: e.target.value,
        state: state.toLowerCase(),
        buttonCounter,
        length,
      });
  };

  return (
    <div className="add-carrier">
      <button className="btn btn-primary" onClick={handleAddCarrierClick}>
        Add Carrier
      </button>
    </div>
  );
};

export default AddCarrier;
